<template>
  <v-container>
    <v-row>
      <v-col>
        <Meal2 :mealId="mealId" :date="date" :read-only="readOnly"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Meal2 from '@/components/Meal2';

export default {
  mounted() {

  },
  data() {
    return {
      dialog: true,
    }
  },
  components: {
    Meal2,
  },
  created() {
  },
  computed: {
    readOnly() {
      return !!this.$route.meta.readOnly;
    },
    mealId() {
      return this.$route.params.id;
    },
    date() {
      return this.$route.params.date;
    },
  },
  methods: {}
}
</script>

